import { render, staticRenderFns } from "./CommunicationOverview.vue?vue&type=template&id=d5d5d520"
import script from "./CommunicationOverview.vue?vue&type=script&lang=js"
export * from "./CommunicationOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports